module.exports = __webpack_public_path__ + "media/images/checkmark-a95f84a3233f3045ce4fce7dd428e2e4.svg";